export const CustomTooltip = ({ active, payload }: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div className="BookEZ_card_bg backdrop-blur-sm p-2 rounded-lg shadow-lg border BookEZ_card_border_color">
        <p className="BookEZ_font_bold  BookEZ_font_color_gray_2">
          {data.name}
        </p>
        <p className="BookEZ_font_body_size BookEZ_font_color_gray_2">
          {data.percentage}
        </p>
      </div>
    );
  }
  return null;
};

export const renderCustomizedLabel = (props: any) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    name,
    percentage,
    fill,
    theme,
  } = props;
  const RADIAN = Math.PI / 180;
  const radius = outerRadius + 35;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  // Calculate control point for the curve
  const curveHeight = 20;
  const midX = cx + (outerRadius + curveHeight) * Math.cos(-midAngle * RADIAN);
  const midY = cy + (outerRadius + curveHeight) * Math.sin(-midAngle * RADIAN);

  // Calculate the extended line end point
  const lineEndX = x + (x > cx ? 30 : -30);
  const isRightSide = x > cx;

  const [mainText, ...rest] = name.split(" ");
  const secondLine = rest.join(" ");
  return (
    <g>
      {/* Curved connecting line with horizontal extension */}
      <path
        d={`
            M${cx + outerRadius * Math.cos(-midAngle * RADIAN)},${
          cy + outerRadius * Math.sin(-midAngle * RADIAN)
        }
            Q${midX},${midY} ${x},${y}
            L${lineEndX},${y}
          `}
        stroke={fill}
        fill="none"
        strokeWidth={1}
      />

      {/* Label text and percentage */}
      <text
        x={lineEndX + (isRightSide ? 8 : -8)}
        y={secondLine ? y - 20 : y}
        textAnchor={isRightSide ? "start" : "end"}
        dominantBaseline="middle"
        fill={theme == "dark" ? "#ffffff" : "#374151"}
      >
        <tspan className="BookEZ_font_body_size BookEZ_font_bold BookEZ_font_color_gray_2 ">
          {mainText}
        </tspan>
      </text>
      {secondLine && (
        <text
          x={lineEndX + (isRightSide ? 8 : -8)}
          y={y - 5}
          textAnchor={isRightSide ? "start" : "end"}
          dominantBaseline="middle"
          fill={theme == "dark" ? "#ffffff" : "#374151"}
        >
          <tspan className="BookEZ_font_body_size BookEZ_font_bold BookEZ_font_color_gray_2 text-nowrap">
            {secondLine}
          </tspan>
        </text>
      )}
      <text
        x={lineEndX + (isRightSide ? 8 : -8)}
        y={y + 20}
        textAnchor={isRightSide ? "start" : "end"}
        dominantBaseline="middle"
        fill={theme == "dark" ? "#ffffff" : "#374151"}
      >
        <tspan
          dx={4}
          className="BookEZ_font_body_size BookEZ_font_color_gray_2"
        >
          {percentage}
        </tspan>
      </text>
    </g>
  );
};
